/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISymptom } from 'app/shared/model/symptom.model';
import { ISymptomAttribute } from 'app/shared/model/symptom-attribute.model';

export interface ISymptomAttributePreference {
  id?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  symptomOrder?: number | null;
  symptom?: ISymptom | null;
  attribute?: ISymptomAttribute | null;
}

export const defaultValue: Readonly<ISymptomAttributePreference> = {
  active: false,
};
